/** Only http(s) links are ever rendered as an href — a stored link comes from
 *  a provider's API (Google Drive, a web search), but the guard costs nothing
 *  and closes the door on `javascript:` and friends. */
export function safeHttpUrl(url: string | null | undefined): string | null {
  if (!url) return null;
  return /^https?:\/\//i.test(url.trim()) ? url.trim() : null;
}
